module.exports = __webpack_public_path__ + "static/img/BU04PB-1.8958569.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU04PB-1.jpg
// module id = Xj9X
// module chunks = 1